import Navbar from './Navbar';

function WhythisApp(){

    return(
        <div id="why-this-app" className='whyThisAppContainer'>
            <div className='whyThisAppWrapper'>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>
                            <div className='main'>Why this App</div>
                            <div className='sub'>(The best OCR tool for precision and simplicity)</div>
                        </div>
                        <div className='content'>
                            <ul>
                                <li>Extracts mixed content with <span className='highlight'>High accuracy</span>.</li>
                                <li><span className='highlight'>Well-formatted</span> output.</li>
                                <li><span className='highlight'>Ad-free</span> user experience.</li>  
                                <li>Supports <span className='highlight'>Translation for 100+ languages</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhythisApp;